export default __webpack_public_path__ + "media/images/features/ja/okinawa-fe3cddd4d1a16ad4554adc1906c45aa0.png";